<template>
  <div class="row flex-lg-nowrap">
    <div
      :class="
        'container-widget order-lg-0 order-1 ' + (isFullScreen && windowWidth > 991 ? 'full-screen' : 'col-lg-10')
      "
    >
      <div class="widget">
        <div class="widget-content">
          <div
            v-if="templateType === templateConstante.TEMPLATE_DOCUMENT_TYPE"
            class="alert alert-info mb-4"
            role="alert"
          >
            <i class="fa fa-info-circle me-2"></i>
            {{ $t("conditions.info") }}
          </div>

          <SortTableComponent
            :columns="columns"
            :datas="datas"
            :maxResult="maxResult"
            :apiFilters="false"
            :loading="loading"
            :actions="actions"
            :keyword="keyword"
            :idKey="0"
            :key="templateType"
            type="template"
            ref="sortTable"
            :isSearchAvailable="true"
            @refresh="refresh"
            @activate="activate"
            @delete="deleteTemplate"
            @duplicate="duplicate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SortTableComponent from "@/components/table/sortTable/SortTableComponent.vue";
import { apiConnection } from "@/services/api-connection";
import { sortableTableManager } from "@/services/utilities/sortable-table-manager";
import { notificationManager } from "@/services/utilities/notification-manager";
import { i18n } from "@/i18n";
import { templateManager } from "@/services/template/template-manager";
import { templateConstante } from "@/constantes/template";

export default {
  name: "TemplateListView",
  components: {
    SortTableComponent,
  },
  data() {
    return {
      isFullScreen: true,
      loading: false,
      editingId: null,
      datas: [],
      columns: [],
      maxResult: 0,
      actions: [],
      windowWidth: window.innerWidth,
      sessionStorageKey: "",
      listParams: [],

      filterModels: [],
      modalTitle: "",
      modalType: "",
      keyword: "",
      modalSubmitText: "",
      isSearchOpen: false,
      isFiltered: false,
      templateType: "",
      editPath: "",
      deletePath: "",
    };
  },
  computed: {
    templateConstante() {
      return templateConstante;
    },
  },
  watch: {
    tabs() {
      this.checkHash();
    },
    $route() {
      this.templateType = this.$route.params.templateType;
      this.editPath = "adminTemplateEdit";
      this.deletePath = `adminTemplateDelete`;

      this.init();
    },
  },
  mounted() {
    this.templateType = this.$route.params.templateType;
    this.editPath = "adminTemplateEdit";
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.setActionsItems();

      apiConnection.get(`/app/admin/template/${this.templateType}/list`, this.listParams).then((data) => {
        this.columns = sortableTableManager.getEntriesColumns(data.columns, this.columns);

        if (this.columns.length > 1) {
          this.columns.splice(0, 1);
        }

        this.datas = data.data;
        this.maxResult = this.datas.length;
        this.loading = false;
      });
    },
    refresh() {
      this.init();
    },
    setActionsItems() {
      this.actions = [
        {
          translation: "admin.modify",
          translationParams: { name: "name", id: "id" },
          icon: "pen",
          type: "success",
          actionType: "router",
          action: this.editPath,
          params: { templateType: this.templateType },
          cfaStyle: false,
          alias: this.alias,
        },
      ];

      if (this.templateType === templateConstante.TEMPLATE_DOCUMENT_TYPE) {
        this.actions.unshift(
          {
            translation: "admin.delete",
            translationParams: { name: "name", id: "id" },
            icon: "trash",
            type: "danger",
            action: "delete",
            showCondition: false,
            conditionIndex: 7,
            cfaStyle: false,
          },
          {
            translation: "admin.template.duplicate",
            translationParams: { name: "name", id: "id" },
            icon: "copy",
            type: "success",
            action: "duplicate",
            showCondition: true,
            conditionIndex: 7,
            cfaStyle: false,
          },
        );
      }
    },

    async deleteTemplate(row) {
      const alertTitle = i18n.global.tc("global.delete.title", 1, {
        name: i18n.global.tc("admin.template.title", 1).toLowerCase(),
      });
      const alertSubtitle = i18n.global.tc("global.delete.sub_title", 0, {
        name: i18n.global.tc("admin.template.title", 1).toLowerCase(),
      });

      const alertConfirmation = await notificationManager.showAlert("error", alertTitle, alertSubtitle, true, true);
      if (!alertConfirmation.isConfirmed) return;

      this.loading = true;
      const response = await templateManager.removeModels(row, this.templateType);
      if (response.success) {
        this.refresh();
      }
    },

    async duplicate(row) {
      const alertTitle = i18n.global.tc("global.copy.title", 1, {
        name: i18n.global.tc("admin.template.title", 1).toLowerCase(),
      });
      const alertSubtitle = i18n.global.tc("global.copy.sub_title", 1, {
        name: i18n.global.tc("admin.template.title", 1).toLowerCase(),
      });

      const alertConfirmation = await notificationManager.showAlert("info", alertTitle, alertSubtitle, true, true);
      if (!alertConfirmation.isConfirmed) return;

      this.loading = true;
      const response = await templateManager.duplicateModels(row, this.templateType);
      if (response.success) {
        this.refresh();
      }
    },

    activate(item, tradGender = 1) {
      const id = item.id;

      const tradPrefix = item.row[1] ? "unactive" : "active";

      notificationManager
        .showAlert(
          "warning",
          i18n.global.tc("global." + tradPrefix + ".title", tradGender, {
            name: i18n.global.tc("admin.template.title", 1).toLowerCase(),
          }),
          i18n.global.tc("global." + tradPrefix + ".sub_title", 2, {
            name: i18n.global.tc(item.row[2], 1).toLowerCase(),
          }),
          true,
          true,
        )
        .then((data) => {
          if (data.isConfirmed) {
            apiConnection
              .get(`/app/admin/template/${this.templateType}/toggle/${id}`)
              .then((data) => {
                if (data.success) {
                  console.log(
                    i18n.global.tc("global." + tradPrefix + ".success", 1, {
                      name: i18n.global.tc(item.row[2], 1).toLowerCase(),
                    }),
                  );
                  notificationManager.showNotification("success", "Succes");
                  this.refresh();
                } else if (!data.success && data.message) {
                  notificationManager.showNotification("error", data.message);
                }
              })
              .catch((error) => {
                console.error(`Erreur lors de ${item.row[1] ? "la désactivation" : "l'activation"} :`, error);
              });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.widget-content {
  padding: 20px;
}
</style>
